import React from "react";
import { Typography, Avatar, Popover, Divider } from "antd";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { getSignOutUrl, getUserInfo, getUserSettingUrl } from "@yuntoo/user";
import styles from "./index.module.css";

export default function UserSlot() {
  const userInfo = getUserInfo();
  const { nickname, username, image: coverUrl } = userInfo;
  const showName = nickname || username || "";

  return (
    <Popover
      classNames={{
        body: styles.userPopover,
      }}
      placement="bottomRight"
      arrow={{ pointAtCenter: true }}
      // trigger={"click"} // just for debug
      trigger={"hover"}
      content={
        <>
          <Typography.Title className={styles.welcome} level={5}>
            Hi! {showName}
          </Typography.Title>
          <Divider className={styles.divider} dashed />
          <ul className={styles.userList}>
            <li onClick={() => window.open(getUserSettingUrl())}>
              <UserOutlined />
              个人设置
            </li>
            <li onClick={() => window.open(getSignOutUrl())}>
              <LogoutOutlined />
              退出登录
            </li>
          </ul>
        </>
      }
    >
      <Avatar
        className={styles.avatar}
        size={32}
        src={coverUrl ? <img src={coverUrl} alt="avatar" /> : null}
      >
        {showName.slice(0, 2)}
      </Avatar>
    </Popover>
  );
}
